<template>
  <footer class="bg-base-200 dark:bg-neutral text-base-content dark:text-neutral-content">
    <!-- Main Footer -->
    <div class="container mx-auto px-4 py-10">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- About Section -->
        <div class="space-y-4">
          <h3 class="text-lg font-bold">FastPano</h3>
          <p class="opacity-75 max-w-md">Android cihazınızda profesyonel slayt gösterimi. QR kod ile web panelinden kolayca yönetin. İnternet gerektirmez.</p>
          <div class="flex space-x-4 mt-4">
            <a 
              href="https://www.instagram.com/fastpano" 
              target="_blank" 
              rel="noopener noreferrer"
              class="btn btn-circle btn-ghost hover:bg-primary/20 transition-all duration-300"
              title="Instagram'da Takip Et"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="space-y-4">
          <h3 class="text-lg font-bold">Hızlı Bağlantılar</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Ana Sayfa
              </router-link>
            </li>
            <li>
              <router-link to="/tos" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Kullanım Şartları
              </router-link>
            </li>
            <li>
              <router-link to="/privacy" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Gizlilik Politikası
              </router-link>
            </li>
            <li>
              <router-link to="/cookie-policy" class="link link-hover inline-flex items-center hover:translate-x-1 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                Çerez Politikası
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="space-y-4">
          <h3 class="text-lg font-bold">İletişim</h3>
          <ul class="space-y-2">
            <li class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>fastpanooffical@gmail.com</span>
            </li>
            <li>
              <button @click="showContactModal = true" class="btn btn-outline btn-sm mt-2">
                Bize Ulaşın
              </button>
            </li>
            <li>
              <div class="dropdown dropdown-top">
                <label tabindex="0" class="btn btn-outline btn-sm mt-2 w-full justify-start">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                  </svg>
                  {{ locale === 'tr' ? '🇹🇷 Türkçe' : '🇬🇧 English' }}
                </label>
                <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow-lg border border-base-300">
                  <li>
                    <button @click="changeLanguage('tr')" :class="{ 'active': locale === 'tr' }">
                      🇹🇷 Türkçe
                    </button>
                  </li>
                  <li>
                    <button @click="changeLanguage('en')" :class="{ 'active': locale === 'en' }">
                      🇬🇧 English
                    </button>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="py-6 border-t border-base-300 dark:border-neutral-focus">
      <div class="container mx-auto px-4 text-center">
        <p class="text-sm opacity-75">Telif Hakkı © {{ new Date().getFullYear() }} FastPano - Tüm hakları saklıdır</p>
      </div>
    </div>

    <!-- Contact Modal -->
    <dialog :class="['modal', { 'modal-open': showContactModal }]">
      <div class="modal-box">
        <h3 class="font-bold text-lg mb-4">Bize Ulaşın</h3>
        <p class="py-4 mb-4">
          Sorularınız, önerileriniz veya destek talepleriniz için bizimle iletişime geçebilirsiniz. 
          Aşağıdaki butona tıklayarak e-posta uygulamanızı açabilirsiniz. (fastpanooffical@gmail.com)
        </p>
        <div class="modal-action">
          <a 
            :href="`mailto:fastpanooffical@gmail.com?subject=FastPano İletişim&body=Merhaba,%0D%0A%0D%0A`"
            class="btn btn-primary"
            @click="showContactModal = false"
          >
            E-posta Gönder
          </a>
          <button class="btn btn-ghost" @click="showContactModal = false">Kapat</button>
        </div>
      </div>
      <form method="dialog" class="modal-backdrop" @click="showContactModal = false">
        <button>close</button>
      </form>
    </dialog>
  </footer>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from '../../compositions/useI18n'

const showContactModal = ref(false)
const { locale, changeLanguage } = useI18n()
</script>